import React from "react";
import { goToInterestForm, utmParams } from "../../utilities/screeningApi";

export default function PublicFooter({ contactEmail, onInterestClick }) {
  return (
    <footer id="contact" className="font-body bg-text-main text-white py-16">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <h4 className="text-xl font-bold font-heading mb-4">PRADAM Study</h4>
            <p className="text-white/80">
              A clinical research study at UCL investigating personalised approaches to treating depression.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold font-heading mb-4">Contact</h4>
            <p className="text-white/80">
              For enquiries about the PRADAM study, please contact the research
              team at UCL
              {contactEmail ? (
                <>
                  {" "}at{" "}
                  <a
                    href={`mailto:${contactEmail}`}
                    className="underline hover:text-white transition-colors"
                  >
                    {contactEmail}
                  </a>
                </>
              ) : null}
              .
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold font-heading mb-4">Links</h4>
            <ul className="space-y-2">
              <li>
                {/* Same destination as every other Express Interest button:
                    the REDCap EOI form, with a booking key. (Used to point at
                    /register, the old pharmacy QR sign-up page — a dead end.) */}
                <button
                  type="button"
                  // Wrapped so that the click event is never taken for the
                  // utm_ values.
                  onClick={onInterestClick || (() => goToInterestForm(utmParams(window.location.search)))}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Express Interest
                </button>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  FAQs
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-white/60">
          © {new Date().getFullYear()} PRADAM Study | Applied Computational Psychiatry Lab, UCL
        </div>
      </div>
    </footer>
  );
}
